<template>
  <div class="my-sidebar-nav-box">
    <ul class="show-flex-box-c">
      <li class="show-flex-box-c" v-for="(item,index) in navList" :key="index">
        <dl class="single-menu-class-box">
          <dt class="show-flex-box-r menu-shrink-status">
            <h3>
              <strong></strong>
              <span>{{item.title}}</span>
              <em></em>
            </h3>
          </dt>
          <dd class="show-flex-box-r">
            <ul class="show-flex-box-c">
              <li
                :class="{'show-flex-box-r show-flex-center': true,'current-select-route': currentRouter == cItem.type}"
                v-for="(cItem,cIndex) in item.children"
                :key="cIndex"
                @click="switchRoute(cItem)"
              >
                <h3>
                  <span>{{cItem.title}}</span>
                  <em v-if="cItem.type == 'messageCenter' && startupData && startupData.un_read_message_count && startupData.un_read_message_count > 0"></em>
                </h3>
              </li>
            </ul>
          </dd>
        </dl>
      </li>
    </ul>
  </div>
</template>

<script>
import regex from "@/filter/regex";
// import {LoginUser} from "@/model/login_user.js";

export default {
  name: "sidebarNavBox",
  data() {
    return {
      navList: [
        {
          title: "个人中心",
          children: [
            {
              title: "开通会员",
              type: "paymentVip",
              dynamic: false,
              path: "/web/my/payment_vip"
            },
            {
              title: "个人资料",
              type: "personalData",
              dynamic: false,
              path: "/web/my/personal_data"
            },
            {
              title: "消息中心",
              type: "messageCenter",
              dynamic: true,
              path: "/web/my/message_center"
            },
            // {
            //   title: "钱包",
            //   type: "myWallet",
            //   dynamic: false,
            //   path: "/web/my/wallet"
            // },
            {
              title: "已购",
              type: "boughtLive",
              dynamic: false,
              path: "/web/my/bought_live"
            },
            {
              title: "收藏",
              type: "myCollect",
              dynamic: false,
              path: "/web/my/collect"
            },
            {
              title: "观看记录",
              type: "watchRecord",
              dynamic: false,
              path: "/web/my/watch_record"
            },
            {
              title: "报名记录",
              type: "registrationRecord",
              dynamic: false,
              path: "/web/my/registration_record"
            }
          ]
        },

        {
          title: "系统",
          children: [
            {
              title: "基础设置",
              type: "setting",
              dynamic: false,
              path: "/web/my/setting"
            },
            {
              title: "意见反馈",
              type: "feedback",
              dynamic: false,
              path: "/web/my/feedback"
            },
            {
              title: "常见问题",
              type: "usualQuestion",
              dynamic: false,
              path: "/web/my/usual_question"
            },
            {
              title: "关于我们",
              type: "aboutUs",
              dynamic: false,
              path: "/web/my/about_us"
            }
          ]
        }
      ],
      currentRouter: "personalData",
      startupData: false
    };
  },
  components: {},
  created() {
    this.startupData = this.listenStartupData;
  },
  computed: {
    listenStartupData: function() {
      return this.$store.state.startup;
    }
  },
  mounted() {
    this.setCurrentRouteChoose();
  },
  methods: {
    setCurrentRouteChoose: function() {
      var routInfo = this.$route;
      this.currentRouter = routInfo.name;
      // alert(JSON.stringify(this.currentRouter))
    },
    switchRoute: function(routInfo) {
      var toWhere = routInfo.path;
      // 高亮由 $route 监听在导航成功后统一设置，避免导航失败时高亮与内容不一致
      this.$router.push({ path: toWhere }).catch(function() {});
    }
  },
  watch: {
    $route: function() {
      this.setCurrentRouteChoose();
    },
    listenStartupData: function() {
      this.startupData = this.listenStartupData;
    }
  }
};
</script>
<style lang="less" scoped>
.my-sidebar-nav-box {
  width: 100%;
  > ul {
    width: 100%;
    > li {
      width: 100%;
      margin-bottom: 20px;
      background: #ffffff;
      > dl {
        width: 100%;
        > dt {
          padding: 31px 124px 20px 44px;
          > h3 {
            flex-shrink: 0;
            position: relative;
            > span {
              font-size: 18px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #333333;
              line-height: 25px;
            }
            > strong {
              position: absolute;
              width: 36px;
              height: 36px;
              background: linear-gradient(
                135deg,
                rgba(203, 19, 9, 0.3) 0%,
                rgba(255, 255, 255, 0) 100%
              );
              border-radius: 50%;
              top: -12px;
              left: -12px;
            }
            > em {
              flex-shrink: 0;
              position: absolute;
              width: 6px;
              height: 6px;
              background: rgba(203, 19, 9, 0.49);
              bottom: 2px;
              right: -3px;
              border-radius: 50%;
            }
          }
        }
        > dd {
          width: 100%;
          > ul {
            width: 100%;
            > li {
              width: 100%;
              height: 60px;
              cursor: pointer;
              > h3 {
                min-width: 64px;
                flex-shrink: 0;
                height: 22px;
                text-align: center;
                line-height: 22px;
                position: relative;
                > span {
                  font-size: 16px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: rgba(51, 51, 51, 1);
                }
                > span:hover {
                  color: #cb1309;
                }
                > em {
                  position: absolute;
                  width: 8px;
                  height: 8px;
                  background: #cb1309;
                  border-radius: 50%;
                  overflow: hidden;
                }
              }
            }
            .current-select-route {
              > h3 {
                > span {
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 500;
                  color: #cb1309;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/my/nav/my_sidebar_nav.vue